<template lang="pug">
.success-container
  .top-block
    .info-block
      .info-block-left
        .info-block-left-big 购买成功
        .info-block-left-small {{title}}
      .info-block-right
        img(src="https://m.hellobike.com/resource/helloyun/08345/-2GieaBCXs.png?x-oss-process=image/quality,q_80")
    .info-word 已发放至帐户【APP ➞ 钱包 ➞ 我的卡】查看
    .info-btn(v-if="!env.isEasyBikeApp" @click="goDownLoad")
      .download-btn 下载哈啰APP使用
    .info-btn(v-else @click="goBike")
      .download-btn 去骑行
  .info-banner
    adv-master(
      v-if="bannerPropById.id"
      class="banner-container"
      :bannerProp="bannerPropById"
      :env="envConfig"
      :systemCode="systemCode"
    )
  .info-img
</template>
<script>
import config from '@/const/config';
import { getSystemCode } from '@/utils/systemCode';
import { AdvMaster } from '@hb/h5-components';
import { startApp } from '@/utils/index';
import { env, Native } from '@hb/NBridge/lib/h5';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { ParamsUtil } from '../../../../utils/params';


export default {
  components: {
    AdvMaster,
  },
  data() {
    return {
      env,
      config: {
        deepLink:
          'https://m.hellobike.com/mf/spa/u_wsjczx/latest/MA2204243054087163443937280.html?activityCode=MA2204243054087163443937280&beyondMP=true',
      },
      envConfig: config.env,
      systemCode: null,
      title: '',
    };
  },
  computed: {
    bannerPropById() {
      return {
        id: '8d2aa1761b0844169c40bdc80b471b78',
        customClick: false,
        style: {
          borderRadius: 0,
          height: 80,
        },
      };
    },
  },
  created() {
    if (getSystemCode) {
      this.systemCode = getSystemCode().toString();
    }
    this.title = this.$route.query.cardTitle;
    if (this.title === '') {
      this.title = ParamsUtil.getParam(window.location.href).cardTitle;
    }
  },
  methods: {
    goDownLoad() {
      UBT.clickButton({
        pageId: 'platform_appmarketing',
        buttonName: 'platform_down',
        categoryId: 'platform',
        businessInfo: {},
      });
      if (env.isWechatMini) {
        window.location.href = 'https://m.hellobike.com/mf/spa/u_wsjczx/latest/MA2204243054087163443937280.html?activityCode=MA2204243054087163443937280';
        return;
      }
      this.goUrl(this.config.deepLink, true);
    },
    goUrl(url = this.config.deepLink, download = false) {
      UBT.clickButton({
        pageId: 'platform_appmarketing',
        buttonName: 'platform_down',
        categoryId: 'platform',
        businessInfo: {},
      });
      if (download && (env.isAliMP || env.isAliMPMonitor)) {
        startApp(url);
        return;
      }
      window.location.href = url;
    },
    goBack() {
      Native.goBack();
    },
    goBike() {
      window.location.href = 'hellobike://hellobike.com/bikehome';
    },
  },
};
</script>
<style lang="less" scoped>
  .success-container {
    height: 100%;
    background: #f0f3f5;
  }

  .top-block {
    height: 2.47rem;
    background: linear-gradient(180deg, #ff253b 0%, #ff2e3f 38%, #ff9d7c 100%);

    .info-block {
      padding: 0.24rem 0 0 0;
      margin: 0 0.36rem;
      display: flex;
      justify-content: space-between;
      border-bottom: 0.01rem dashed #fff;

      .info-block-left {
        .info-block-left-big {
          font-size: 0.24rem;
          font-family: PingFangSC-Semibold, PingFang SC, sans-serif;
          font-weight: 600;
          color: #fff;
          line-height: 0.33rem;
        }

        .info-block-left-small {
          font-size: 0.14rem;
          font-family: PingFangSC-Medium, PingFang SC, sans-serif;
          font-weight: 500;
          color: #f7f9fa;
          line-height: 0.2rem;
        }
      }

      .info-block-right {
        width: 0.62rem;
        height: 0.66rem;

        img {
          width: 0.62rem;
          height: 0.66rem;
        }
      }
    }

    .info-word {
      margin: 0.1rem 0.36rem 0 0.36rem;
      font-size: 0.12rem;
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      font-weight: 400;
      color: #fff;
      line-height: 0.17rem;
    }

    .info-btn {
      display: flex;
      justify-content: center;
      margin-top: 0.16rem;

      .download-btn {
        width: 1.97rem;
        height: 0.42rem;
        background: #fff;
        border-radius: 8px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC, sans-serif;
        font-weight: 500;
        color: #ff3543;
        text-align: center;
        line-height: 0.42rem;
      }
    }
  }

  .info-banner {
    margin-top: -0.4rem;

    .banner-container {
      width: 100%;
      display: flex;
      justify-content: center;
      height: 0.8rem;
    }
  }

  /deep/ .wrapper {
    height: 0.8rem;
    border-radius: 0.12rem;
  }
</style>
